import type { ModuleId } from './types';

// Mirrors the src/config blogSlug formula exactly (VITE_BLOG_NAME → lowercase,
// spaces→hyphens). Computed here so src/modules/ is self-contained.
const blogName: string = import.meta.env.VITE_BLOG_NAME || 'Blog';
export const blogSlug: string = blogName.toLowerCase().replace(/\s+/g, '-');

/**
 * Path prefixes each module OWNS. Survives tree-shaking (no manifest imports),
 * which is the whole point: menu filtering must recognize a DISABLED module's
 * paths even though its manifest was eliminated from the bundle.
 * A module owns `p` and everything under `p/`.
 */
export const MODULE_PATHS: Record<ModuleId, string[]> = {
  blog: [`/${blogSlug}`],
  contact: ['/contact'],
  // freshSTART fork: '/store' is the CORE Donate page (src/pages/Donate.tsx via
  // DynamicPage), so ecommerce must not own it — otherwise the Donate nav item is
  // filtered out whenever ecommerce is off (PRD v0.4).
  ecommerce: ['/ecommerce-demo'],
  elearning: ['/elearning'],
  social: ['/smPosts'],
  booking: ['/book', '/booking', '/my-bookings'],
  admin: ['/admin'],
  payments: ['/invoice'],
  'customer-auth': ['/auth'],
  crm: [], // admin-only module
  email: [], // admin-only module
  reviews: ['/review'],
  // freshSTART fork: /events is the CORE Get Involved page (src/App.tsx route), so the
  // events module owns no menu path — Get Involved stays in the nav even with events off.
  events: [],
};

/** Boundary-aware ownership: '/admin' owns '/admin/x' but NOT '/administrator'.
 *  External URLs and hash links are owned by no module. */
export const findOwningModule = (path: string): ModuleId | null => {
  if (path.startsWith('http') || path.includes('#')) return null;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  for (const [id, prefixes] of Object.entries(MODULE_PATHS)) {
    if (prefixes.some((p) => normalized === p || normalized.startsWith(`${p}/`))) {
      return id as ModuleId;
    }
  }
  return null;
};
